var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[_c('Tooltip',{attrs:{"text":_vm.$capitalize(_vm.$t('your account'))}},[_c('AccountUserInfo',{attrs:{"active":_vm.isExpanded},on:{"profileClick":_vm.profileClick}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }